import {
	RESET_MANDATE_LIST,
	MANDATE_ACTIVE_TAB,
	MANDATE_ACTIVE_FILTER,
	GET_MANDATES_MULTIPART_SUCCESS,
	VIEW_MANDATE,
	VIEW_ARCHIVE_MANDATE,
	EDIT_MANDATE,
	SET_ACTIVE_SORT_ORDER,
	SET_ARCHIVE_SORT_ORDER,
	SET_ACTIVE_PAGE,
	SET_ARCHIVE_PAGE,
	SET_MANDATE_TOTALS,
} from './actions';
import {
	ACTIVE_TAB,
	MANDATE_RECORD_TYPE_ACTIVE,
	MANDATE_RECORD_TYPE_ARCHIVED,
	MANDATE_PAGE_SIZE,
	MANDATE_FILTER_ALL,
} from '../../config';

const initialMandateState = {
	standingOrders: [],
	directDebits: [],
	bacs: [],
	ifts: [],
};
const initialState = {
	...initialMandateState,
	mandateActiveTab: ACTIVE_TAB,
	mandateActiveFilter: MANDATE_FILTER_ALL,
	mandateToEdit: undefined,
	mandateActivePage: 1,
	mandateArchivePage: 1,
	mandateActiveTotal: 0,
	mandateArchiveTotal: 0,
	mandateRecordType: MANDATE_RECORD_TYPE_ACTIVE,
	mandateStartIndex: 0,
	mandateMaxRecords: MANDATE_PAGE_SIZE,
};

const managePayments = (state = initialState, action) => {
	switch (action.type) {
		case RESET_MANDATE_LIST:
			return {
				...state,
				...initialMandateState,
			};
		case VIEW_ARCHIVE_MANDATE:
		case VIEW_MANDATE:
			return {
				...state,
				mandateToView: action.mandate,
			};
		case GET_MANDATES_MULTIPART_SUCCESS:
			return {
				...state,
				...action.mandates,
			};
		case MANDATE_ACTIVE_TAB:
			const setMandateRecordType =
				action.mandateActiveTab === ACTIVE_TAB ? MANDATE_RECORD_TYPE_ACTIVE : MANDATE_RECORD_TYPE_ARCHIVED;

			return {
				...state,
				mandateActiveTab: action.mandateActiveTab,
				mandateRecordType: setMandateRecordType,
			};
		case MANDATE_ACTIVE_FILTER:
			return {
				...state,
				mandateActiveFilter: action.mandateActiveFilter,
				mandateActivePage: 1,
			};
		case EDIT_MANDATE:
			return {
				...state,
				mandateToEdit: action.mandateId,
			};
		case SET_ACTIVE_SORT_ORDER:
			return {
				...state,
				activeSortOrder: action.sortOrder,
				mandateActivePage: 1,
			};
		case SET_ARCHIVE_SORT_ORDER:
			return {
				...state,
				archiveSortOrder: action.sortOrder,
				mandateArchivePage: 1,
			};
		case SET_ACTIVE_PAGE:
			return {
				...state,
				mandateActivePage: action.pageNumber,
				mandateStartIndex: (action.pageNumber - 1) * MANDATE_PAGE_SIZE,
			};
		case SET_ARCHIVE_PAGE:
			return {
				...state,
				mandateArchivePage: action.pageNumber,
			};
		case SET_MANDATE_TOTALS:
			const { mandateActivePageTotal, mandateArchivePageTotal } = action.totals;
			return {
				...state,
				mandateActivePageTotal,
				mandateArchivePageTotal,
			};
		default:
			return state;
	}
};

export default managePayments;
